import Vue from 'vue'
import Router from 'vue-router'

if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
  Vue.prototype.$pc = false
} else {
  Vue.prototype.$pc = true
  let winWidth = document.documentElement.offsetWidth ||
  document.body.offsetWidth
  winWidth = winWidth < 1366 ? 1366 : winWidth
  let oHtml = document.getElementsByTagName('html')[0]
  oHtml.style.fontSize = 100 * winWidth / 1920 + 'px'
  window.addEventListener('resize', function () {
      let winWidth = document.documentElement.offsetWidth || document.body.offsetWidth
      winWidth = winWidth < 1366 ? 1366 : winWidth
      let oHtml = document.getElementsByTagName('html')[0]
      oHtml.style.fontSize = 100 * winWidth / 1920 + 'px';
  })
}

Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Vue.prototype.$pc?(resolve)=>require(['@/page/index/index'],resolve):(resolve)=>require(['@/page/index_p/index'],resolve)
    },
    {
      path: '/WMS',
      name: '/WMS',
      component: Vue.prototype.$pc?(resolve)=>require(['@/page/index/WMS'],resolve):(resolve)=>require(['@/page/index_p/WMS'],resolve)
    },
    {
      path: '/TMS',
      name: '/TMS',
      component: Vue.prototype.$pc?(resolve)=>require(['@/page/index/TMS'],resolve):(resolve)=>require(['@/page/index_p/TMS'],resolve)
    },
    {
      path: '/contactUs',
      name: '/contactUs',
      component: Vue.prototype.$pc?(resolve)=>require(['@/page/index/contactUs'],resolve):(resolve)=>require(['@/page/index_p/contactUs'],resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js